import { z } from "zod";
import { API_URL } from "./config";
import { SOCIAL } from "./config";

const authorProfileSchema = z.object({
  slug: z.string(),
  name: z.string(),
  headline: z.string(),
  job_title: z.string(),
  article_role: z.string(),
  company: z.string(),
  location: z.string(),
  postal_code: z.string(),
  country_code: z.string(),
  email: z.string().email(),
  about_intro: z.string(),
  profile_intro: z.string(),
  profile_bio: z.string(),
  article_bio: z.string(),
  seo_description: z.string(),
  about_seo_description: z.string(),
  contact_seo_description: z.string(),
  linkedin_url: z.string().url(),
  github_url: z.string().url(),
  specializations: z.array(
    z.object({
      icon: z.enum(["cpu", "radio", "workflow", "shield-check"]),
      title: z.string(),
      description: z.string(),
    }),
  ),
  updated_at: z.string().nullable().optional(),
});

export type AuthorProfile = z.infer<typeof authorProfileSchema>;

export interface AuthorSocialLinks {
  linkedin: string;
  github: string;
}

export function getAuthorSocial(
  profile?: Pick<AuthorProfile, "linkedin_url" | "github_url"> | null,
): AuthorSocialLinks {
  return {
    linkedin: profile?.linkedin_url || SOCIAL.linkedin,
    github: profile?.github_url || SOCIAL.github,
  };
}

export async function fetchAuthorProfile(slug = "jignesh-mevada"): Promise<AuthorProfile> {
  const response = await fetch(`${API_URL}/api/authors/${encodeURIComponent(slug)}`, {
    cache: "no-store",
  });
  if (!response.ok) {
    throw new Error(`Failed to load author profile (HTTP ${response.status})`);
  }
  return authorProfileSchema.parse(await response.json());
}

export function getAuthorInitials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0] ?? "")
    .join("")
    .toUpperCase();
}
